import type { ReactNode } from 'react';
import { Select } from '@mantine/core';
import { IconUser } from '@tabler/icons-react';
import { useMemberComboboxOptions } from '@/hooks';
import type { WorkspaceMember } from '@/types/workspace';
import { ICON_SIZE_SM } from '@/constants/ui';
import { Z_INDEX_MOBILE_MODAL_DATEPICKER } from '@/constants/zIndex';
import { LoadingState } from '../loading';

export interface MemberSelectViewProps {
  readonly value: string | null;
  readonly onChange: (value: string | null) => void;
  readonly members: WorkspaceMember[];
  readonly isMembersLoading: boolean;
  readonly label?: string;
  readonly placeholder?: string;
  readonly className?: string;
  readonly disabled?: boolean;
  readonly error?: ReactNode;
}

export function MemberSelectView({
  value,
  onChange,
  members,
  isMembersLoading,
  label,
  placeholder,
  className,
  disabled,
  error,
}: MemberSelectViewProps): ReactNode {
  const { options, renderOption, filter } = useMemberComboboxOptions(members);

  return (
    <Select
      className={className}
      label={label}
      placeholder={placeholder}
      leftSection={<IconUser size={ICON_SIZE_SM} />}
      rightSection={
        isMembersLoading ? <LoadingState mode="spinner" size="xs" /> : undefined
      }
      data={options}
      value={value}
      onChange={onChange}
      renderOption={renderOption}
      filter={filter}
      searchable
      clearable
      disabled={disabled}
      error={error}
      comboboxProps={{
        zIndex: Z_INDEX_MOBILE_MODAL_DATEPICKER,
        withinPortal: true,
      }}
    />
  );
}
